import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ForgotpasswordService {
  constructor(private apiService: ApiService) {}
  changePassword(email: string, new_password: string): Observable<any> {
    const body = {
      email,
      new_password,
    };
    return this.apiService.post<any>(`/v1/auth/change-password`, body);
  }
  fetchOtp(email: string): Observable<any> {
    const fetchOtpData = {
      email: email,
    };
    return this.apiService.post(`/v1/auth/reset-password`, fetchOtpData);
  }
  validateOtp(email: string, otpCode: string): Observable<any> {
    const validateOtpData = {
      email: email,
      code: otpCode,
    };
    return this.apiService.post(`/v1/auth/validate-code`, validateOtpData);
  }
}
